import { z } from "zod";

export const POST_allChallenges = {
  params: z.object({}),
  body: z.object({}),
  query: z.object({
    limit: z.coerce.number().optional(),
    page: z.coerce.number().optional(),
    sort: z.enum(["new-to-old", "old-to-new"]).optional(),
  }),
};